import { useSelector } from 'react-redux';

const useGetToken = () => {
    return useSelector((state) => state.ansa_token.ansa_token);
};

export default useGetToken;